import styled from 'styled-components';
const H1 = styled.h1 `
  display: flex;
  align-items: center;
  padding-bottom: 8px;
  border-bottom: 3px dotted #d9d9d9;
`;
export default H1;
